import angular from 'angular';

export class FolhasPontoFalhaGeracaoModalService {
    static $inject = ['$uibModal'];

    constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

    open(msg: string) {
        return this.$uibModal.open({
            template: require('html-loader!./falhageracao.modal.html'),
            controller: 'FolhasPontoFalhaGeracaoModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => angular.copy(msg)
            }
        });
    }
}
